<template>
  <v-layout row wrap>
    <ProceedModal ref="ProceedModal" />
    <v-toolbar dense dark>
      <v-toolbar-title>Customers</v-toolbar-title>
    </v-toolbar>

    <v-layout row>
      <v-flex xs12>
        <v-list>
          <v-list-group v-for="item in CustomersWithVenues" :key="item.ID" no-action>
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-avatar>
                  <v-icon>mdi-domain</v-icon>
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title>{{ item.Customer.Name }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>

            <v-list-tile v-for="subItem in item.Venues" :key="subItem.ID">
              <v-list-tile-content>
                <v-list-tile-title>{{ subItem.Name }}</v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-menu absolute v-if="subItem.CheckedIn == false">
                  <template v-slot:activator="{ on }">
                    <v-btn color="success" dark v-on="on" small>
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-tile @click="checkIn(subItem)">
                      <v-list-tile-title>Check In</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
                <v-btn v-else dark color="success" @click="goToVenue(subItem)" small>
                  <v-icon>mdi-play</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list-group>
        </v-list>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
  import JWT from "jsonwebtoken";
  import moment from "moment";
  import supervisorMW from "@/libs/middleware/supervisorMW";

  export default {
    data() {
      return {
        CustomersWithVenues: [],
        items: [],
        CustomerVenueList: [],
        CustomerList: [],
        IDBVenueList: [],
        IDBCustomerList: [],
        CheckInLong: null,
        CheckInLat: null,
        SystemUserID: null,
        sessionData: {},
        tokenData: {},
        LSCheckedInVenues: [],
      };
    },
    mounted() {
      let self = this;

      //self.sessionData = self.$store.getters.getUserSessionData;
      //self.tokenData = JWT.decode(self.sessionData.AccessToken);
      //self.SystemUserID = self.tokenData.USER_ID;
      // self.GetLocation();
      self.GetLocalStorageCheckedInVenues();
      self.fetchCustomers();
    },
    methods: {
      GetLocalStorageCheckedInVenues() {
        let self = this;

        self.LSCheckedInVenues = JSON.parse(localStorage.getItem("CheckedInVenues"));
        console.log("[CHECKED IN VENUES]", self.LSCheckedInVenues)
      },
      fetchCustomers() {
        let self = this;
        let mw = new supervisorMW(self);

        self.CustomersWithVenues = [];
        mw.GetUserData().then(r => {
          console.log("[USER DATA]", r[0]);
          self.SystemUserID = r[0].UserID;
          r[0].CustomerList.forEach(customer => {
            self.IDBCustomerList.push(customer.Customer); // CUSTOMER LIST
            self.CustomerList = self.IDBCustomerList;

            customer.Venues.forEach(venue => {
              if (self.LSCheckedInVenues != null) {
                if (self.LSCheckedInVenues.includes(venue.CustomerVenue.ID)) {
                  venue.CustomerVenue.CheckedIn = true;
                }
              }

              self.IDBVenueList.push(venue.CustomerVenue); // VENUE LIST
              self.CustomerVenueList = self.IDBVenueList.filter(ven => {
                return ven.CustomerID == customer.Customer.ID;
              })
            })
            let Request = {
              Customer: customer.Customer,
              Venues: self.CustomerVenueList
            }
            self.CustomersWithVenues.push(Request)

          })
        })
        .catch(e => {
          console.error("[FAILED TO GET DATA]", e.toString())
        })
        self.$nextTick(() => {
          console.log('[CUSTOMERS WITH VENUES]', self.CustomersWithVenues)
        })
      },
      ProcessCustomerVenues() {
        let self = this;
        console.log('wtf')

      },
      checkIn(venue) {
        let self = this;

        self.$refs.ProceedModal.show(
          "Checking in requires internet connectivity. Please make sure you are connected to WiFi.",
          function (yes) {
            if (yes == true) {
              self.GetLocation();
              var CheckedInVenues = JSON.parse(localStorage.getItem('CheckedInVenues') || "[]");

              if (!(CheckedInVenues instanceof Array))
                CheckedInVenues = [CheckedInVenues];
              CheckedInVenues.push(venue.ID);
              localStorage.setItem('CheckedInVenues', JSON.stringify(CheckedInVenues));
              setTimeout(() => {
                let Request = {
                  CustomerVenueID: venue.ID,
                  SystemUserID: self.SystemUserID,
                  CheckInLong: self.CheckInLong,
                  CheckInLat: self.CheckInLat
                }
                console.log('CHECK IN', Request)

                self.post(`CheckInOut/CheckIn`, Request)
                  .then(r => {
                    let storeData = {
                      CustomerID: venue.CustomerID,
                      VenueID: venue.ID
                    };
                    self.$store.commit("setLastCheckInData", storeData);
                    self.$router.push(`/Supervisor/Inspections/Allocated/${venue.ID}`);
                  })
                  .catch(e => {
                    console.error("[CHECK IN FAILED]", e.toString())
                  })
              }, 200)
            }
          }
        )
        // self.post(`CheckInOut/CheckIn`, {
        //     CustomerVenueID: venue.ID,
        //     SystemUserID: self.SystemUserID,
        //     CheckInLong: self.CheckInLong,
        //     CheckInLat: self.CheckInLat
        //   })
        //   .then(r => {
        //     let storeData = {
        //       CustomerID: venue.CustomerID,
        //       VenueID: venue.ID
        //     };
        //     self.$store.commit("setLastCheckInData", storeData);
        //     self.$router.push(`/Supervisor/Inspections/Allocated/${venue.ID}`);
        //   });
      },
      GetLocation() {
        let self = this;
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            self.showPosition,
            self.locationError
          );
        } else {
          self.location = "Geolocation is not supported by this browser.";
        }
      },
      showPosition(position) {
        let self = this;
        self.location =
          "Latitude: " +
          position.coords.latitude +
          ", Longitude: " +
          position.coords.longitude;
        //self.showInMap(position);
        self.CheckInLong = position.coords.longitude;
        self.CheckInLat = position.coords.latitude;
        console.log("LOCATION", self.location);
      },
      goToVenue(venueItem) {
        let self = this;
        let storeData = {
          CustomerID: venueItem.CustomerID,
          VenueID: venueItem.ID
        };

        self.$store.commit("setLastCheckInData", storeData);
        self.$router.push(`/Supervisor/Inspections/Allocated/${venueItem.ID}`);
      }
    }
  };
</script>

<style>
</style>